























import { Component, Vue,Watch } from 'vue-property-decorator'
import {getLocalItem} from '@/utils'
import  NoData from '@/components/NoData'

@Component({
    components:{
        NoData
    }
})
export default class EnergySupervision  extends Vue {
    private pdfUrl:any=null
    mounted(){
        const that =this
        setTimeout(function(){
        that.pdfUrl=getLocalItem('energySavingSystemUrl')
        },1000)
    }
}
